require('fslightbox');

export function Lightbox() {
    const coreImagesThatLinkToMedia = document.querySelectorAll("figure.wp-block-image > a > img, .wp-caption > a > img, .gallery a > img, .blocks-gallery-item a > img");
    for (const image of coreImagesThatLinkToMedia) {
        const parentLink = image.parentElement;
        if (parentLink.getAttribute('href').match(/\.jpg|\.jpeg|\.png|\.svg|\.gif/)) {
            parentLink.setAttribute('data-fslightbox', true)
        }
    }
    refreshFsLightbox();
}